module.exports = __webpack_public_path__ + "img/mv--avatar3--sp.599c5af3.png";